import Script from 'next/script';
import { FC, useEffect, useState } from 'react';

import { captureError } from '../../../../utils/capture';

interface Props {
  onApprove: () => void;
  paymentID: string;
}

export const CryptoCom: FC<Props> = ({ onApprove, paymentID }) => {
  const [ready, setReady] = useState(false);
  const buttonID = 'crypto-com-button';

  useEffect(() => {
    if (typeof window === 'undefined') return () => {};

    if (window.cryptopay && ready && paymentID) {
      window.cryptopay
        .Button({
          createPayment: (actions) => actions.payment.fetch(paymentID),
          onApprove,
        })
        .render(`#${buttonID}`);
    }

    return () => {
      const button = document.getElementById(buttonID);
      if (button) {
        button.innerHTML = '';
      }
    };
  }, [onApprove, paymentID, ready]);

  if (typeof window === 'undefined') return null;

  return (
    <>
      <Script
        async
        defer
        onError={captureError}
        onReady={() => setReady(true)}
        src={`https://js.crypto.com/sdk?publishable-key=${process.env.NEXT_PUBLIC_CRYPTO_COM_PUBLISH_KEY}`}
        strategy="lazyOnload"
      />

      <div id={buttonID} />
    </>
  );
};
